import axiosClient from '../axiosClient';
import { OrdersEndpoints } from '../endpoints/orders';
import {
  IGetOrdersResponse,
  IOrderDetail,
  IDispatchOrderResponse,
} from '../../types/api/response/ordersresponse';
import { IDispatchOrderRequest } from '../../types/api/request/ordersrequest';
import { IGetOrderCallbacksResponse } from '../../types/api/response/ordercallbacksresponse';

export const OrdersService = {
  async getOrders(
    page: number = 0,
    size: number = 20,
    search?: string,
  ): Promise<IGetOrdersResponse> {
    const res = await axiosClient.get<IGetOrdersResponse>(OrdersEndpoints.GET_ORDERS, {
      params: { page, size, ...(search ? { search } : {}) },
    });
    return res.data;
  },
  async getOrderDetail(orderNumber: string): Promise<IOrderDetail> {
    const res = await axiosClient.get<IOrderDetail>(OrdersEndpoints.GET_ORDER_DETAIL(orderNumber));
    return res.data;
  },
  // Gated by "Order Diagnostics" in the admin API — a 403 means the user lacks it.
  async getOrderCallbacks(
    orderNumber: string,
    page: number = 0,
    size: number = 20,
  ): Promise<IGetOrderCallbacksResponse> {
    const res = await axiosClient.get<IGetOrderCallbacksResponse>(
      OrdersEndpoints.GET_ORDER_CALLBACKS(orderNumber),
      { params: { page, size } },
    );
    return res.data;
  },
  async dispatchOrder(
    orderNumber: string,
    payload: IDispatchOrderRequest,
  ): Promise<IDispatchOrderResponse> {
    const res = await axiosClient.post<IDispatchOrderResponse>(
      OrdersEndpoints.DISPATCH_ORDER(orderNumber),
      payload,
    );
    return res.data;
  },
};
